import {
	type PartnerBillingProfileUpdateDto,
	patchPartnersPartnerIdBillingProfilesId,
} from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import { Resources, useResource } from "Infrastructure/Translation/Resources";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";

const partnerMutationsResource = Resources.base.partner.mutations;

export const useUpdateBillingProfile = (
	partnerId: number,
	id?: number | null,
) => {
	const { t } = useResource();
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: processResponse((data: PartnerBillingProfileUpdateDto) => {
			if (!id) {
				return Promise.reject(
					new Error("Billing Profile ID is required for updating."),
				);
			}
			return patchPartnersPartnerIdBillingProfilesId(data, partnerId, id);
		}),
		onError: (error) => {
			console.error(
				`${t(partnerMutationsResource.partnerBillingProfileUpdateError)}:`,
				error,
			);
		},
		onSuccess: () => {
			toast.success(
				t(partnerMutationsResource.partnerBillingProfileUpdateSuccess),
			);
			queryClient.invalidateQueries({
				queryKey: ["PARTNER_DETAIL", partnerId],
			});
		},
	});
};
